class GeroNoResultsCollection {
  render(target, variant) {
    if (null == target) {
      return;
    }

    const block = this.template.content.cloneNode(true).querySelector(".gero-no-results");

    block.classList.add(variant);
    target.replaceChildren(block);
  }

  init() {
    this.template = document.getElementById("gero-no-results-collection");

    if (null == this.template || null == this.template.content.querySelector(".gero-no-results")) {
      return;
    }

    GeroSnizeEvents.onResults((container) => {
      this.render(container.querySelector("li.snize-no-products-found"), "is-results");
    });

    GeroSnizeEvents.onAutocomplete((container) => {
      this.render(container.querySelector(".snize-nothing-found"), "is-compact");
    });
  }
}

if ("loading" == document.readyState) {
  document.addEventListener("DOMContentLoaded", () => {
    new GeroNoResultsCollection().init();
  });
} else {
  new GeroNoResultsCollection().init();
}
